/* @refresh reload */
import { resetCSSBody } from "./utils/css/reset-css-body";
import { initialize } from "@/tools/init";

// Run the CSS reset immediately when the script is executed to prevent layout shifts.
resetCSSBody();

// Initialize mock server (if enabled) and register web component
await initialize();
